import styled, { css } from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledExpandMenu = styled.div<{ $expanded?: boolean }>`
  background-color: white;
  box-sizing: border-box;
  border-right: 1px solid ${theme.colors.purple_2};
  width: 72px;
  position: relative;
  z-index: 10;
`;

const EXPANDED_WIDTH_PX = 300;

export const StyledExpandContainer = styled.div<{ $expanded?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ $expanded }) => ($expanded ? `${EXPANDED_WIDTH_PX}px` : "72px")};
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px 10px 0px 16px;
  background-color: white;
  border-right: 1px solid ${theme.colors.purple_2};
  transition: width 0.3s cubic-bezier(0, 1, 0.13, 1);
  box-sizing: border-box;
  z-index: 10;

  & > div:first-child {
    display: flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
  }
`;

export const StyledExpandMenuItemsContainer = styled.div<{
  $expanded?: boolean;
}>`
  flex-direction: column;
  gap: 16px;
  background-color: white;
  display: flex;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  padding-bottom: 20px;
`;

export const StyledExpandMenuItem = styled.div<{
  $active: boolean;
  $disabled?: boolean;
  $expanded?: boolean;
}>`
  border-radius: ${theme.variables.border_radius_1};
  cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
  height: 32px;
  display: flex;
  align-items: center;
  user-select: none;
  ${({ $expanded }) =>
    $expanded
      ? css`
          justify-content: flex-start;
          padding: 0 10px 0 10px;
          width: 100%;
        `
      : css`
          justify-content: center;
          width: 32px;
        `};

  ${({ $active }) =>
    $active
      ? css`
          background-color: ${theme.colors.purple};
          z-index: 2;
          cursor: pointer;
        `
      : null};

  &:hover {
    ${({ $disabled }) =>
      $disabled
        ? null
        : css`
            background-color: ${theme.colors.purple};
            cursor: pointer;
          `};
  }
`;

export const StyledExpandMenuItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 4px;
`;

export const StyledUnreadMarkWrapper = styled.div<{ $visible: boolean }>`
  flex-shrink: 0;
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
`;
